export const TITLES_LOAD = "titles/LOAD";
export const TITLES_SET = "titles/SET";

export const loadTitles = (payload: any) => ({ type: TITLES_LOAD, payload });
